import {Injectable} from '@angular/core';
import {MatSnackBar, MatSnackBarRef} from '@angular/material/snack-bar';
import {MessageComponent} from '../components/message/message.component';
import {Observable} from 'rxjs';
import {HelpInfo} from '../../admin/models/help-info.interface';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';

const HELP_INFO_API = environment.apiUrl + 'help-info';

@Injectable()
export class MessageService {
  private snackBarRef!: MatSnackBarRef<MessageComponent>;

  constructor(private snackBar: MatSnackBar, private http: HttpClient) {
  }

  showMessage = (message: string, type: string, duration = 5000) => {
    if (this.snackBarRef) {
      this.snackBarRef.dismiss();
      this.snackBar.dismiss();
    }
    this.snackBarRef = this.snackBar.openFromComponent(MessageComponent, {
      verticalPosition: 'top',
      panelClass: type,
      data: {message},
      duration,
    });

  }

  getDialogInfo(code: string): Observable<HelpInfo> {
    return this.http.get<HelpInfo>(`${HELP_INFO_API}/${code}`);
  }

}

